import type { ApiResponse } from '@api/types/api-response';
import api from '.';
import {
  ROUTE as UPDATE_STATS_ROUTE,
  Params as UpdateStatsParams,
  Result as UpdateStatsResult,
} from '@api/routes/user/update-stats/params';

export const user = api.injectEndpoints({
  endpoints: builder => ({
    updateStats: builder.mutation<ApiResponse<UpdateStatsResult>, UpdateStatsParams>({
      query: params => ({
        method: 'POST',
        url: UPDATE_STATS_ROUTE,
        body: params,
      }),
    }),
  }),
  overrideExisting: false,
});
